import { useLocation } from "react-router-dom";

/**
 * Hook to determine if the current route is within the admin section
 */
const useIsAdminSection = () => {
    const location = useLocation();
    return location.pathname.includes('admin');
};

export default useIsAdminSection;
